module.exports = __webpack_public_path__ + "static/media/RoundedRect_Red.b21e703f.png";